module.exports = __webpack_public_path__ + "static/media/receipt.408a1fbd.png";